<template>
  <svg
    v-if="values && values.length > 1"
    class="sparkline"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
  >
    <path class="sparkline-line" :d="linePath" />
    <circle
      class="sparkline-dot"
      :cx="lastPoint.x"
      :cy="lastPoint.y"
      r="2.6"
    />
    <circle
      v-if="markerIndex !== null && points[markerIndex]"
      class="sparkline-marker"
      :cx="points[markerIndex].x"
      :cy="points[markerIndex].y"
      r="3.2"
    />
  </svg>
</template>

<script>
export default {
  name: "Sparkline",

  props: {
    values: {
      type: Array,
      required: true,
    },

    width: {
      type: Number,
      default: 62,
    },

    height: {
      type: Number,
      default: 22,
    },

    pad: {
      type: Number,
      default: 3,
    },

    domainMin: {
      type: Number,
      default: null,
    },

    domainMax: {
      type: Number,
      default: null,
    },

    markerIndex: {
      type: Number,
      default: null,
    },
  },

  computed: {
    points() {
      const hasDomain = this.domainMin !== null && this.domainMax !== null;
      const min = hasDomain ? this.domainMin : Math.min(...this.values);
      const max = hasDomain ? this.domainMax : Math.max(...this.values);
      const range = max - min || 1;
      const step = (this.width - this.pad * 2) / (this.values.length - 1);
      return this.values.map((v, i) => ({
        x: this.pad + i * step,
        y: this.pad + (this.height - this.pad * 2) * (1 - (v - min) / range),
      }));
    },

    linePath() {
      return this.points
        .map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`)
        .join(" ");
    },

    lastPoint() {
      return this.points[this.points.length - 1];
    },
  },
};
</script>

<style scoped>
.sparkline {
  flex: none;
  display: block;
}

.sparkline-line {
  fill: none;
  stroke: rgba(35, 15, 55, 0.72);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.sparkline-dot {
  fill: rgba(35, 15, 55, 0.85);
}

.sparkline-marker {
  fill: #510087;
  stroke: #fff;
  stroke-width: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/sparkline.vue